import React from "react";
import Brand from "../components/Brand";
import Button from "../components/Button";
import Persona from "../components/Persona";

export const StyleGuide = () => {
  return (
    <div style={{ minHeight: "100vh", background: "#F2F9FC" }}>
      <div style={{ width: "50%", margin: "auto" }}>
        <div style={{ textAlign: "start" }}>
          <h2
            style={{ paddingTop: "50px", margin: "0px", textAlign: "center" }}
          >
            Style Guide
          </h2>
          <h3 style={{ marginTop: "50px" }}>Buttons/Colors</h3>
          <hr></hr>
          <div
            style={{
              display: "flex",
              justifyContent: "start",
              marginBottom: "15px",
              marginTop: "15px",
            }}
          >
            <div style={{ marginRight: "10px" }}>
              <Button type="primary" size="large">
                Primary
              </Button>
            </div>
            <div style={{ marginRight: "10px" }}>
              <Button type="secondary" size="large">
                Secondary
              </Button>
            </div>
            <div>
              <Button size="large" className="btn-outlined" outline={true}>
                Outline
              </Button>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "start" }}>
            <div style={{ marginRight: "10px" }}>
              <Button type="primary" size="small">
                Primary Small
              </Button>
            </div>
            <div style={{ marginRight: "10px" }}>
              <Button type="secondary" size="small">
                Secondary small
              </Button>
            </div>
            <div>
              <Button size="small" className="btn-outlined" outline={true}>
                Outline small
              </Button>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "start",
              marginTop: "20px",
            }}
          >
            <div style={{ marginRight: "10px" }}>
              <Persona
                icon="fitness_center"
                text="Fitness"
                onClick={() => console.log(1)}
              ></Persona>
            </div>
            <div style={{ marginRight: "10px" }}>
              <Persona
                icon="library_music"
                text="Music"
                onClick={() => console.log(1)}
              ></Persona>
            </div>
            <div style={{ marginRight: "10px" }}>
              <Persona
                icon="games"
                text="Video Games"
                onClick={() => console.log(1)}
              ></Persona>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "start",
              marginTop: "20px",
            }}
          >
            <div style={{ marginRight: "10px" }}>
              <Brand
                logo="nike"
                text="Nike"
                onClick={() => console.log(1)}
              ></Brand>
            </div>
            <div style={{ marginRight: "10px" }}>
              <Brand
                logo="brooks"
                text="Brooks"
                onClick={() => console.log(1)}
              ></Brand>
            </div>
            <div style={{ marginRight: "10px" }}>
              <Brand
                logo="dell"
                text="Dell"
                onClick={() => console.log(1)}
              ></Brand>
            </div>
          </div>
        </div>
        <div style={{ textAlign: "start" }}>
          <h3>Forms</h3>
          <hr></hr>
          <div
            style={{
              width: "40%",
              display: "flex",
              justifyContent: "start",
              flexDirection: "column",
            }}
          >
            <div
              className="input-field"
              style={{ marginTop: "10px", marginBottom: 0 }}
            >
              <input
                id="default-input"
                type="email"
                className="validate"
                required
              />
              <i className="material-icons icon">check</i>
              <label htmlFor="default-input">Email Input</label>
              <span className="helper-text" data-error="Invalid Email"></span>
            </div>
            <div className="input-field">
              <input
                id="password-input"
                type="password"
                className="validate"
                required
              />
              <i className="material-icons icon">check</i>
              <label htmlFor="password-input">Password Input</label>
              <span className="helper-text" data-error="Required"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
